<template>
	<div>
		<div class="cover" ref="cover" v-show="!chooseToDisappear">
			<div id='tip-container' :class="`br_${platformInfo.skin}`">
				<img :src="titleUrl" id='search-tip-title'/>
				<div class='tip'><div :class="`tip-no bg-font_${platformInfo.skin}`">1</div><div class='tip-content'>可搜索证件照规格名称，如“签证”</div></div>
				<div class='tip'><div :class="`tip-no bg-font_${platformInfo.skin}`">2</div><div class='tip-content'>可搜索像素大小，如“413”</div></div>
				<div class='tip'><div :class="`tip-no bg-font_${platformInfo.skin}`">3</div><div class='tip-content'>可搜索纸质照片尺寸，如“35”</div></div>
				<div class='tip'><div :class="`tip-no bg-font_${platformInfo.skin}`">4</div><div class='tip-content'>可搜索文件大小，如“100”</div></div>
				<div id='close-tip' :class="`bg_${platformInfo.skin} br_${platformInfo.skin}`" @click="closeTip">我知道了</div>
			</div>
		</div>
		<div class="realPage">
			<div :class="`search-area bg_${platformInfo.skin}`">
				<div :class="`search-inner-area br_${platformInfo.skin}`">
			   <img src='../assets/icon_search.png' class="search-icon" />
				<div class="search-txt-area">
				  <input :placeholder="defaultSearchValue" v-model="searchWord" @keyup.enter="searchByTap(searchWord || defaultSearchValue)" class="search-txt"/>
				</div>
				<img src='../assets/icon_del.png' class="search-close" @click="clear" />
				</div>
				<div class='cancel' @click="cancel">取消</div>
			 </div>
			<div class="marginFixed">
				<!-- 历史搜索 -->
				<div v-if="!searchResults" class="searchItems">
					<div class="searchItemList" v-if="historySearch">
						<div class="item-title">
							<span>历史搜索：</span>
							<div class="title-img" @click="delHistory">
								<svg viewBox="0 0 512 512" id="bin" width="100%" height="100%">
									<path d="M64 160v320c0 17.6 14.4 32 32 32h288c17.6 0 32-14.4 32-32V160H64zm96 288h-32V224h32v224zm64 0h-32V224h32v224zm64 0h-32V224h32v224zm64 0h-32V224h32v224zM424 64H320V24c0-13.2-10.8-24-24-24H184c-13.2 0-24 10.8-24 24v40H56c-13.2 0-24 10.8-24 24v40h416V88c0-13.2-10.8-24-24-24zm-136 0h-96V32.401h96V64z"></path>
								</svg>
							</div>
						</div>
						<ul>
							<search-word v-for="(word, key) in historySearch" :searchWord="word" :key="key" @searchThisItem="searchByTap">
							</search-word>
						</ul>
					</div>

					<!-- 热门搜索 -->
					<div class="searchItemList">
						<div class="item-title">
							<span>热门搜索：</span>
						</div>
						<div class="hot-search-open-tip" @click="openTip">如何搜索？</div>
						<ul>
							<search-word v-for="(word, key) in hotSearch" :searchWord="word" :key="key" @searchThisItem="searchByTap">
							</search-word>
						</ul>
					</div>
				</div>
				<div class="searchResultList" v-else>
					<!--搜索没有结果的情况下，显示的界面-->
					<div v-if="noResult">
						<div class="no-result">
							<img src="../assets/no_result.png" />
							<div id='no-result-tip'>没有找到你要的证件照规格</div>
							<div id='no-result-open-tip' :class="`br_${platformInfo.skin}`" @click="openTip">点击查看搜索教程</div>
						 </div>
					</div>
					<!--搜索有结果的情况下，显示结果-->
					<div v-else>
						<result-items v-for="item in searchResults" :item="item" :key="item.specs_id" @showDetailInfo="showSpecDetail">
						</result-items>
					</div>
				</div>
			</div>

		</div>
		

	</div>
</template>

<script>
	import { mapMutations, mapState, mapActions } from "vuex";
	import { config } from "@/config/config";
	import SearchWord from "@/components/SearchWord";
	import ResultItems from "@/components/SearchResultItem";
	import { historySearch } from "@/utils/utils";

	export default {
		components: {
			SearchWord,
			ResultItems
		},
		data() {
			return {
        titleUrl: require(`../assets/skins/${this.$store.state.platformInfo.skin}/searchTipTitle.png`),
				searchWord: null,
				defaultSearchValue: "美国签证", //默认搜索值
				historySearch: null, //历史搜索
				noResult: false, //结果集长度
				chooseToDisappear:true
			};
		},
		methods: {
			...mapMutations(["RECORD_SPECINFO", "RECORD_SEARCH_RESULTS", "RECORD_LAST_SEARCH","RECORD_HOTSEARCH", "RECORD_PLATFORMINFO_LOCAL"]),
			...mapActions(['getHot','searchByKeywords']),
			delHistory() {
				this.historySearch = null;
				historySearch.delete();
			},
			//record search value by enter or tab list item
			searchByTap(keyWord) {
				let keyWord_s = keyWord.toString();
				historySearch.add(keyWord_s);
				this.historySearch = historySearch.getHistorySearchData();
				this.search(keyWord_s);
			},
			search: function(keyWord) {
				this.searchWord = keyWord;
				this.searchByKeywords(keyWord)
					.then(({
						data: {
							specs
						}
					}) => {
						console.log(specs);
						this.RECORD_LAST_SEARCH(keyWord);
						this.RECORD_SEARCH_RESULTS(specs);
						console.log(specs);
						if(specs.length == 0) {
							this.noResult = true;
						} else {
							this.noResult = false;
						}
					})
			},
			showSpecDetail: function(specInfo) {
				console.log(specInfo)
				this.RECORD_SPECINFO(specInfo);
				let platformInfo = {
					...this.platformInfo,
					...specInfo
				}
				this.RECORD_PLATFORMINFO_LOCAL(platformInfo)
				//navigator to photo-making page
				this.$router.push({
					name: "spec"
				});
			},
			clear:function() {
				this.searchWord=null;
			},
			cancel:function(){
				this.sdk.navigateBack();
			},
			openTip:function() {
				this.$refs.cover.style.display = 'inline';
			},
			closeTip: function() {
				this.$refs.cover.style.display = 'none';
			}
		},
		created() {
			this.getHot().then(res => {
				this.RECORD_HOTSEARCH(res.data.result);
			});
			if(this.lastSearchWord) {
				this.searchWord = this.lastSearchWord;
			}
			this.historySearch = historySearch.getHistorySearchData();
		},
		beforeMount() {

		},
		computed: {
			...mapState(["searchResults", "lastSearchWord", "hotSearch","platformInfo"]),
		},

		watch: {
			//当searchValue没有值，清空搜索结果（清除搜索结果，再输入的时候，不能出现上次的搜索结果）
			searchWord(val) {
				if(!val) {
					this.RECORD_LAST_SEARCH(val);
					this.RECORD_SEARCH_RESULTS(null);
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.realPage {
		height: 100vh;
	}
	
	.item-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: 700;
		margin-bottom: 0.2rem;
		color: #666666;
		font-size: 0.13rem;
	}
	
	.title-img {
		width: 0.12rem;
	}
	
	.searchItemList {
		padding: 0.12rem 0.15rem;
		background-color: #ffffff;
		position: relative;
	}
	
	//默认height100%占了一页
	.mint-search {
		height: auto;
		width: 100%;
		position: fixed;
		top: 0;
	}
	
	.hot-search-open-tip{
	  position: absolute;
	  font-size: 0.12rem;
	  color:#999999;
	  top: 0.15rem;
	  right: 0.2rem;
	}
	
	.searchItems {
		background-color: #ffffff;
	}
	
	.no-result{
	  text-align: center;
	  background-color: #FFF;
	  padding: 0.28125rem;
	}
	.no-result image{
	  width: 0.88rem;
	  height: 0.8rem;
	  margin-bottom: 0.09375rem
	}
	#no-result-tip{
	  font-size: 0.15rem;
	  margin: 0.05625rem 0;
	  color:#999999;
	  font-size: 0.12rem; 
	}
	#no-result-open-tip{
	  width:1.6rem;
	  height:0.36rem;
	  background:rgba(255,246,232,1);
	  // border-radius:0.18rem;
	  border:1px solid rgba(245,166,35,1);
	  font-size:0.13rem;
	  color:rgba(245,166,35,1);
	  line-height:0.36rem;
	  margin:  0.2rem auto;
	}
	
	.cover {
		padding: 0;
		margin: 0;
		z-index: 10;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
	}
	
	#tip-container{
	  width: 3rem;
	  height: 3.3rem;
	  margin:1.19rem auto;
	  background:rgba(255,255,255,1);
	  // border-radius:0.04rem;
	}
	#search-tip-title{
	  width: 3rem;
	  height: 0.9rem;
	  margin-bottom: 0.24rem;
	//   background: url("../assets/searchTipTitle.png") no-repeat;
	//   background-size: cover;
	}
	.tip{
	  width: 2.6rem;
	  margin: auto;
	  margin-bottom: 0.1rem;
	}
	.tip-no{
	  width:0.27rem;
	  height:0.27rem;
	  background:rgba(255,255,255,1);
	  box-shadow:0px 2px 4px 0px rgba(82,84,255,0.14);
	  border-radius: 50%;
	  font-size:0.15rem;
	  // color:rgba(68,128,231,1);
	  line-height:0.27rem;
	  text-align: center;
	  display: inline-block;
	}
	.tip-content{
	  width:2.18rem;
	  margin-left: 0.15rem;
	  display: inline-block;
	  font-size:0.14rem;
	  color:rgba(102,102,102,1);
	  line-height:0.27rem;
	}
	#close-tip{
	  width:2.5rem;
	  height:0.44rem;
	  // background:rgba(68,128,231,1);
	  // border-radius:0.22rem;
	  font-size:0.16rem;
	  line-height: 0.44rem;
	  color:rgba(255,255,255,1);
	  text-align: center;
	  margin-left: 0.24rem;
	  margin-top: 0.1rem;

	}

	.search-area{
	  // background-color: #4480E7;
	  padding: 0.09375rem 0.1875rem; 
	  overflow: hidden;
	  display:flex;
	  align-items: center;
	  justify-content: space-between;
	  height: 0.55rem;
	  box-shadow:0px 0.06rem 0.08rem 0px rgba(236,236,236,0.5);
	}
	.search-inner-area{
	  width: 3rem;
	  height: 0.38rem;
	  // border-radius:0.04rem;
	  background:rgba(255,255,255,1);
	  display: flex;
	}
	.cancel{
	  width: 0.31rem;
	  height: 0.21rem;
	  color: #FFF;
	  font-size: 0.15rem;
	  position: relative;
	  left: 0.05rem;
	  flex-shrink: 0;
	}
	.search-icon{
	  height: 0.18rem;
	  width: 0.18rem;
	  margin: 0.1rem 0 0.1rem 0.19rem;
	  display: inline-block;
	}
	.search-txt{
	  font-size: 0.14rem;
	  line-height: 0.22rem;
	  height: 0.22rem;
	  width:1.95rem;
	  border: none;
    outline: none;
	}
	.search-txt-area{
	  display: inline-block;
	  margin: 0.08rem 0 0.08rem 0.1rem;
	  background: #FFF;
	  width: 2.15rem;
	}
	.search-close{
	  height: 0.15rem;
	  width: 0.15rem;
	  margin:0.115rem 0.18rem 0.115rem 0.05rem;
	  display: inline-block;
	}
</style>